import { Button, CircularProgress, Dialog, DialogContent } from '@mui/material'
import React from 'react'

export default function ConfirmDialog({ open, setOpen, rows, handleSubmit, loadingSubmit }) {
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth='xl'
        >
            <DialogContent>
                <div class="d-flex row align-items-center mb-4">
                    <div class="col-12">
                        <label style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#3364af',
                        }}>
                            รายการรับหลังปรับปรุง {/* {{data?.header}} */}
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 table-responsive-sm ">
                        <table class="table table-borderless  ">
                            <thead>
                                <tr>
                                    <th class="text-center">เอกสารที่อ้างถึง</th>
                                    <th class="text-center" >เมล็ดพันธุ์</th>
                                    <th class="text-center" >เมล็ดพันธุ์</th>
                                    <th class="text-center" >ฤดู</th>
                                    <th class="text-center" >กลุ่มพันธุ์</th>
                                    <th class="text-center" >ปีที่ผลิต</th>
                                    <th class="text-center" >ล็อตที่</th>
                                    <th class="text-center" >ประเภทบรรจุภัณฑ์</th>
                                    <th class="text-center" >จำนวน (กระสอบ)</th>
                                    <th class="text-center" >ปริมาณ (กิโลกรัม)</th>
                                    <th class="text-center" >ปริมาณเฉลี่ย/กระสอบ</th>
                                    <th class="text-center" >โรงเก็บที่</th>
                                    <th class="text-center" >หมายเหตุ</th>
                                </tr>
                            </thead>
                            <tbody class="">
                                {rows?.map((item, i) => (
                                    <tr>
                                        <td class="text-center">{item?.RefNo || '-'}</td>
                                        <td class="text-center">{item?.ItemNo?.ItemName}</td>
                                        <td class="text-center">{item?.ItemNo?.Option2}</td>
                                        <td class="text-center">{item?.ItemNo?.Season}</td>
                                        <td class="text-center">{item?.ItemNo?.Option1}</td>
                                        <td class="text-center">{item?.Year}</td>
                                        <td class="text-center">{`${item?.LotGen || ''} ${item?.Lot}`}</td>
                                        <td class="text-center">{item?.MaterialName || item?.MaterialNo?.ItemName}</td>
                                        <td class="text-center">{item?.MaterialQty || '-'}</td>
                                        <td class="text-center">{item?.Qty || '-'}</td>
                                        <td class="text-center">{item?.OtyPer?.toFixed(2) || (+item?.Qty / +item?.MaterialQty)?.toFixed(2)}</td>
                                        <td class="text-center">{`${item?.WarehouseName || item?.WarehouseNo?.WarehouseName} ${item?.ZoneName || item?.ZoneNo?.ZoneName}`}</td>
                                        <td class="text-center">{item?.Remark || '-'}</td>
                                    </tr>))}
                            </tbody>
                        </table>
                    </div>


                </div>
                <div class="row mt-4">

                    <div class="col-12 text-end">
                        <Button onClick={() => setOpen(false)} variant='outlined' sx={{ width: "150px", marginRight: '20px' }}>ยกเลิก</Button>
                        <Button disabled={loadingSubmit} onClick={() => handleSubmit('Y')} variant='contained' sx={{ width: "150px", marginRight: '20px' }}>{loadingSubmit ? <CircularProgress size={'24px'} color="inherit" /> : 'ยืนยันการทำรายการ'}</Button>
                    </div>
                </div >
            </DialogContent >
        </Dialog >
    )
}
